<template>
  <div class="about">
    <header>
      <img src="../../assets/background.png">
    </header>
    <div class="cxcz">
      <h3>查询充值</h3>
      <input v-model="value" class="wby2" placeholder="请输入您的物联卡号码">
    </div>
    <div class="btnbox">
      <button @click="getInitNum">查询</button>
    </div>
    <footer>
      <p>操作提示：</p>
      <p>1.充值即时生效</p>
      <p>2.请打开POS机后盖，取出sim卡</p>
      <p>3.输入sim卡背面89860....起始的20位串号</p>
      <p>4.如末尾是英文,则输入前19位串号即可</p>
      <p>(英文是隐藏阿拉伯数字)</p>
    </footer>
    <footer class="icpBox" @click="link()">
      粤ICP备18159823号-1
    </footer>
  </div>
</template>

<script>
import {
  rechargeList
} from '@/api/api.js'
import {
  Dialog,
  Toast
} from 'vant'
export default {
  components: {},
  props: {},
  data () {
    return {
      value: '',
      iccid: '',
      flagIndex: 0,
      timer: ''
    }
  },
  watch: {
    flagIndex: function (res) {
      if (res === 10) {
        clearInterval(this.times)
        Toast('查询失败请稍后重试')
        this.times = ''
        this.flagIndex = 0
      }
    }
  },
  computed: {},
  methods: {
    async link () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    async getInitNum () {
      if (this.value === '') return Toast.fail('请输入物联卡号码')
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '查询卡号中...'
      })
      this.flagIndex = 0
      this.times = setInterval(_ => {
        this.flagIndex++
      }, 500)
      const {
        data: res
      } = await rechargeList({
        iccid: this.value
      })
      if (res.code === 4041000) {
        Toast.clear()
        return Dialog.alert({
          title: '提示',
          message: res.errMsg,
          confirmButtonText: '我知道了'
        }).then(() => {
          // 或者 this.value = ''; // 清空输入框
        })
      }
      this.iccid = JSON.parse(JSON.stringify(this.value))
      if (res.carrier === '联通') {
        this.iccid = res.iccid
      }
      if (res.code === 1) {
        clearInterval(this.times)
        this.times = ''
        this.flagIndex = 0
        const inputValue = this.value.trim()
        if (inputValue.length === 20 && inputValue.startsWith('89860')) {
          Toast.clear()
          return Dialog.alert({
            title: '提示',
            message: '您的卡片需要先转移到新系统才能充值。<br>请联系客服协助处理。',
            confirmButtonText: '我知道了'
          }).then(() => {
            // 或者 this.value = ''; // 清空输入框
          })
        } else {
          return Toast.fail('请输入正确的卡号')
        }
      }
      const that = this
      // this.$store.commit('setType', 'queryRecharge')
      this.$store.commit('setType', 'recharge')
      this.$store.commit('setCarrier', res.carrier)
      if (!res.carrier) {
        clearInterval(this.times)
        this.times = ''
        this.flagIndex = 10
        return
      }
      that.changURL()
    },
    changURL () {
      clearInterval(this.times)
      this.times = ''
      this.$router.push({
        name: 'Recharge',
        params: {
          iccid: this.iccid
        }
      })
    }
  },
  beforeCreate () {
    // const defaultHref = process.env.VUE_APP_DOMAIN + '/#/QueryRecharge'
    // if (location.href !== defaultHref) {
    //   location.href = defaultHref
    // }
  },
  created () {
    this.$store.commit('setFlag', false)
    this.$store.commit('setOrder', '')
    this.$store.commit('setType', 'recharge')
    const iccid = this.$route.params.iccid ?? ''
    if (iccid) {
      this.value = iccid
      this.getInitNum()
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .about {
    height: 100%;
    text-align: center;
    color: #70a413;

    header {
      img {
        width: 100%;
      }
    }

    .cxcz {
      padding: 0 24px;

      h3 {
        text-align: center;
        line-height: 83px;
        font-size: 40px;
        color: #70a413;
        font-weight: 400;
        margin-top: -10px;
      }

      .wby2 {
        margin-top: 5px;
        width: 100%;
        line-height: 88px;
        height: 88px;
        padding: 1px 4px;
        border: none;
        border-bottom: 1px solid #d0d0d0;
        border-top: 1px solid #d0d0d0;
        color: #a5a5a5;
        font-size: 30.4px;
      }
    }

    .btnbox {
      margin-top: -2px;
      background-color: #fff;
      padding: 26px 0;

      button {
        display: block;
        background: linear-gradient(-45deg, #77bc2b, #acd31e);
        border-radius: 20px;
        border: none;
        width: 100%;
        height: 100px;
        line-height: 105px;
        text-align: center;
        font-size: 38px;
        color: #fff;
      }
    }

    footer {
      margin-top: -3px;
      text-align: left;
      color: #818181;
      padding: 0 23.438px 23.438px;
      font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;

      p {
        font-size: 30.5px;
        line-height: 59px;
      }

      p:last-child {
        margin-left: 18px;
      }
    }

    .icpBox {
      font-size: 35px;
      color: #818181;
      position: absolute;
      bottom: 2px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }
  }
</style>
